// extracted by mini-css-extract-plugin
export default {"carCard":"EpuVehicle-module__carCard--K5aIv","model":"EpuVehicle-module__model--1WnLU","visitReason":"EpuVehicle-module__visitReason--m5P+4"};